import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import PackageIcon from "@redotech/redo-icons/package.svg";
import { BooleanFilterOperator } from "@redotech/redo-views-common/advanced-filters/boolean-filter";
import { BooleanTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.usedParcelLearning;

export const UsedParcelLearningFilter: BooleanTableFilter = {
  type: entry.type,
  data: {
    name: entry.name,
    type: entry.type,
    value: null,
    operator: BooleanFilterOperator.IS,
  },
  Icon: PackageIcon,
  displayName: entry.displayName,
  label: "Package learning",
  boolDisplay: { falseDisplay: "not used", trueDisplay: "used" },
};
